var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.spinner},[(_vm.error)?_c('base-icon',{class:_vm.$style.error,attrs:{"name":"error"}}):_c('app-spinner'),_vm._v(" "),(_vm.text)?_c('div',{class:_vm.$style.text,domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }